// import { setupAgeVerification } from "./components/ageVerification";

// import { allAnimationsBefore, allAnimationsAfter } from "./animations/allAnimations";
// import { scrollToTopOnLoad } from "./utils/scroll-back-to-top";
// import { preloadImages } from "./utils/preloadImages";
// import { getBrowserType } from "./utils/defineBrowser";

// scrollToTopOnLoad();
// allAnimationsBefore();
// preloadImages();

// $(document).ready(function () {
//   getBrowserType();
//   setupAgeVerification();
//   allAnimationsAfter();
// });

// // test for loading first
// import { setupAgeVerification } from "./components/ageVerification";
// import { allAnimationsAfter } from "./animations/allAnimations";
// import { scrollToTopOnLoad } from "./utils/scroll-back-to-top";
// import { preloadImages } from "./utils/preloadImages";
// import { getBrowserType } from "./utils/defineBrowser";
// import { preloadImagesPadded } from "./utils/preloadImages";

// const FRAMES_BOTTLE = 120;
// const FRAMES_ANGLE = 60;

// const preloadAll = Promise.all([
//   preloadImagesPadded("/uploads/images/3d/jr-dark", FRAMES_BOTTLE),
//   preloadImagesPadded("/uploads/images/3d/jr-angle", FRAMES_ANGLE),
// ]);

// function withTimeout(p, ms) {
//   return Promise.race([p, new Promise((res) => setTimeout(res, ms))]);
// }

// scrollToTopOnLoad();
// gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

// // start preloading ASAP (not in load)
// withTimeout(preloadAll, 1500).then(() => {
//   // this may resolve early if timeout hits; that’s fine
// });

// function initSmoothScroll() {
//   ScrollTrigger.matchMedia({
//     "(min-width: 768px)": () => {
//       ScrollSmoother.create({
//         wrapper: "#smooth-wrapper",
//         content: "#smooth-content",
//         smooth: 1,
//         effects: true,
//         smoothTouch: false,
//       });
//     },
//   });
// }

// function initSite() {
//   getBrowserType();
//   setupAgeVerification();
//   allAnimationsAfter();
//   if (window.gsap && window.ScrollTrigger) {
//     gsap.registerPlugin(ScrollTrigger);
//     ScrollTrigger.refresh();
//     setTimeout(() => ScrollTrigger.refresh(), 250);
//   }
//   document.body.classList.add("is-loaded");
// }

// // On load, ensure smoother + final refresh happen,
// // but do NOT *start* preloading here.
// window.addEventListener("load", async () => {
//   initSmoothScroll();
//   // wait until preload finished or timeout already elapsed
//   await withTimeout(preloadAll, 0);
//   // one more refresh after images are definitely cached
//   if (window.ScrollTrigger) {
//     ScrollTrigger.refresh();
//     requestAnimationFrame(() => ScrollTrigger.refresh());
//   }
//   setTimeout(initSite, 100); // small settle time for iOS toolbars
// });

// // test for faster animations
// // script.js
// import { setupAgeVerification } from "./components/ageVerification";
// import { preloadImagesPadded } from "./utils/preloadImages";
// import { allAnimationsAfter } from "./animations/allAnimations";
// import { getBrowserType } from "./utils/defineBrowser";

// const FRAMES_BOTTLE = 120;
// const FRAMES_ANGLE = 60;

// let preloadAll; // will be created AFTER modal is shown

// function withTimeout(p, ms) {
//   return Promise.race([p, new Promise((res) => setTimeout(res, ms))]);
// }

// // ✅ Show modal first, THEN start preloading.
// document.addEventListener("DOMContentLoaded", () => {
//   setupAgeVerification(); // fade in modal

//   // start preloading as soon as DOM is ready (after modal exists)
//   preloadAll = Promise.all([
//     preloadImagesPadded("/uploads/images/3d/jr-dark", FRAMES_BOTTLE),
//     preloadImagesPadded("/uploads/images/3d/jr-angle", FRAMES_ANGLE),
//   ]);
// });

// function initSmoothScroll() {
//   ScrollTrigger?.matchMedia({
//     "(min-width: 768px)": () => {
//       ScrollSmoother?.create?.({
//         wrapper: "#smooth-wrapper",
//         content: "#smooth-content",
//         smooth: 1,
//         effects: true,
//         smoothTouch: false,
//       });
//     },
//   });
// }

// function initSite() {
//   getBrowserType();
//   allAnimationsAfter();
//   if (window.gsap && window.ScrollTrigger) {
//     gsap.registerPlugin(ScrollTrigger);
//     ScrollTrigger.refresh();
//     setTimeout(() => ScrollTrigger.refresh(), 250);
//   }
//   document.body.classList.add("is-loaded");
// }

// // Keep your load-time stuff as-is, but wait on preloads if defined
// window.addEventListener("load", async () => {
//   initSmoothScroll();

//   if (preloadAll) {
//     // let it race with a short timeout so UI isn’t blocked
//     await withTimeout(preloadAll, 1500);
//   }

//   if (window.ScrollTrigger) {
//     ScrollTrigger.refresh();
//     requestAnimationFrame(() => ScrollTrigger.refresh());
//   }

//   setTimeout(initSite, 100);
// });

// no preload at all

// script.js

// import { setupAgeVerification } from "./components/ageVerification";
// import { allAnimationsAfter } from "./animations/allAnimations";
// import { getBrowserType } from "./utils/defineBrowser";

// function initSite() {
//   getBrowserType();
//   allAnimationsAfter();

//   if (window.gsap && window.ScrollTrigger) {
//     gsap.registerPlugin(ScrollTrigger);
//     ScrollTrigger.refresh();
//     setTimeout(() => ScrollTrigger.refresh(), 250);
//   }

//   document.body.classList.add("is-loaded");
// }

// function initSmoothScroll() {
//   ScrollTrigger?.matchMedia({
//     "(min-width: 768px)": () => {
//       ScrollSmoother?.create?.({
//         wrapper: "#smooth-wrapper",
//         content: "#smooth-content",
//         smooth: 1,
//         effects: true,
//         smoothTouch: false,
//       });
//     },
//   });
// }

// // tiny helper
// function hasAgeCookie() {
//   return document.cookie.includes("age-verification-yes=true");
// }

// // ensure we only boot once
// let booted = false;
// function bootOnce() {
//   if (booted) return;
//   booted = true;
//   initSmoothScroll();
//   initSite();
// }

// document.addEventListener("DOMContentLoaded", () => {
//   // Show age gate (or immediately clear it if cookie already set)
//   setupAgeVerification({
//     // You can start super-light preloads here if you ever want, but for now: no-op
//     onShow: () => {
//       // console.log("Age gate visible");
//     },
//     onAccept: () => {
//       // User just tapped "Yes" → boot the site
//       bootOnce();
//     },
//   });

//   // If already verified this session, boot right away
//   if (hasAgeCookie()) {
//     bootOnce();
//   }
// });
// import { bootWebsite } from "./app/boot";
// bootWebsite();

// script.js
import { setupAgeVerification } from "./components/ageVerification";
import { allAnimationsAfter } from "./animations/allAnimations";
import { getBrowserType } from "./utils/defineBrowser";
import { setupScrollRefresh } from "./utils/setupScrollRefresh";
import { addIdsToSections } from "./utils/addIdsToSections";
import { openMenuSidenav } from "./utils/openMenuSidenav";
import { cookieConent } from "./utils/cookieConent";
import { imageSequenceIconsSwap } from "./animations/common/imageSequenceIconsSwap";

let refreshBus = setupScrollRefresh(); // start listening right away

function initSite() {
  getBrowserType();
  allAnimationsAfter();

  if (window.gsap && window.ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
    // ScrollTrigger.refresh();
    // setTimeout(() => ScrollTrigger.refresh(), 250);
  }

  document.body.classList.add("is-loaded");

  // If something changed layout during init
  window.dispatchEvent(new CustomEvent("layout:changed"));
}

// function initSmoothScroll() {
//   if ($("body").hasClass("index_1")) {
//     // If you rely on ScrollTrigger.matchMedia:
//     ScrollTrigger.config({
//       ignoreMobileResize: true,
//     });
//     ScrollTrigger?.matchMedia({
//       "(min-width: 768px)": () => {
//         const isTouch = ScrollTrigger.isTouch === 1;

//         const isLandscapePhone = window.matchMedia("(orientation: landscape) and (max-height: 500px)").matches;

//         if (isLandscapePhone && isTouch) {
//           // Just set up the "plain" refresh bus, no smoother
//           refreshBus = setupScrollRefresh();
//           refreshBus.refreshAll("desktop-landscape-no-smoother");
//           return;
//         }
//         const smoother = ScrollSmoother?.create?.({
//           wrapper: "#smooth-wrapper",
//           content: "#smooth-content",
//           smooth: 1,
//           effects: true,
//           smoothTouch: false,
//         });

//         // Recreate the refresh bus bound to smoother
//         refreshBus = setupScrollRefresh({ smoother });

//         // First refresh with smoother in place
//         refreshBus.refreshAll("after-smoother-create");
//       },
//       "(max-width: 767px)": () => {
//         // Ensure we still have a bus on mobile without smoother
//         refreshBus = setupScrollRefresh();
//         refreshBus.refreshAll("mobile-no-smoother");
//       },
//     });
//   }

//   // If you *don’t* want to depend on ScrollTrigger.matchMedia,
//   // you can detect width manually and still call setupScrollRefresh({ smoother }) after creating smoother.
// }

function initSmoothScroll() {
  if (!$("body").hasClass("index_1")) return;

  // Avoid crazy reflows on mobile resize/orientation
  ScrollTrigger.config({
    ignoreMobileResize: true,
  });

  let smoother = null; // shared reference across breakpoints
  const isMobile = window.matchMedia("(pointer: coarse)").matches;

  ScrollTrigger.matchMedia({
    "(min-width: 768px)": () => {
      const isTouch = ScrollTrigger.isTouch === 1;
      const isLandscapePhone = window.matchMedia("(orientation: landscape) and (max-height: 500px)").matches;

      // ---- DESKTOP WIDTH but LANDSCAPE PHONE: NO SMOOTHER ----
      if (isTouch && isLandscapePhone) {
        // kill any previous smoother if we had one
        if (smoother) {
          smoother.kill();
          smoother = null;
        }

        refreshBus = setupScrollRefresh();
        refreshBus.refreshAll("desktop-landscape-no-smoother");

        // cleanup when we leave this media query
        return () => {
          // nothing extra to clean here
        };
      }

      // ---- REAL DESKTOP: WITH SMOOTHER ----
      smoother = ScrollSmoother?.create?.({
        wrapper: "#smooth-wrapper",
        content: "#smooth-content",
        smooth: 1,
        effects: true,
        smoothTouch: false,
      });

      refreshBus = setupScrollRefresh({ smoother });
      refreshBus.refreshAll("after-smoother-create");

      // IMPORTANT: cleanup when width goes below 768
      return () => {
        if (smoother) {
          smoother.kill();
          smoother = null;
        }
      };
    },

    "(max-width: 767px)": () => {
      // pure mobile: no smoother
      if (isMobile) {
        if (smoother) {
          // if we’re coming from desktop, kill smoother
          smoother.kill();
          smoother = null;
        }

        refreshBus = setupScrollRefresh();
        refreshBus.refreshAll("mobile-no-smoother");

        // cleanup when leaving mobile (optional here)
        return () => {
          // nothing special
        };
      }
    },
  });

  window.addEventListener("load", () => {
    ScrollTrigger.refresh();
  });
}

function setupBreakpointReload() {
  const isMobileDevice = window.matchMedia("(pointer: coarse)").matches;
  const BREAKPOINT = 768;

  // ---------------------------
  // DESKTOP / LAPTOP BEHAVIOUR
  // ---------------------------
  if (!isMobileDevice) {
    let lastBucket = window.innerWidth < BREAKPOINT ? "narrow" : "wide";
    let resizeTimer = null;

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        const currentBucket = window.innerWidth < BREAKPOINT ? "narrow" : "wide";

        if (currentBucket !== lastBucket) {
          // We crossed the breakpoint: reload to re-init smoother + scenes cleanly
          location.reload();
        }

        lastBucket = currentBucket;
      }, 200); // debounce; adjust if needed
    });

    return; // ✅ done for desktop
  }

  // ---------------------------
  // MOBILE / TABLET BEHAVIOUR
  // ---------------------------
  // Here we reload when orientation changes (portrait <-> landscape)
  let lastOrientation = window.matchMedia("(orientation: portrait)").matches ? "portrait" : "landscape";
  let orientationTimer = null;

  // Modern way – fires on rotation
  window.addEventListener("orientationchange", () => {
    clearTimeout(orientationTimer);
    orientationTimer = setTimeout(() => {
      const nowPortrait = window.matchMedia("(orientation: portrait)").matches;
      const currentOrientation = nowPortrait ? "portrait" : "landscape";

      if (currentOrientation !== lastOrientation) {
        location.reload();
      }

      lastOrientation = currentOrientation;
    }, 250); // small delay to let viewport settle
  });

  // (Optional) Safety net using resize, in case some browsers
  // don't reliably fire orientationchange:
  window.addEventListener("resize", () => {
    clearTimeout(orientationTimer);
    orientationTimer = setTimeout(() => {
      const nowPortrait = window.matchMedia("(orientation: portrait)").matches;
      const currentOrientation = nowPortrait ? "portrait" : "landscape";

      if (currentOrientation !== lastOrientation) {
        location.reload();
        lastOrientation = currentOrientation;
      }
    }, 250);
  });
}

let booted = false;
function bootOnce() {
  if (booted) return;
  booted = true;
  initSmoothScroll();
  setupBreakpointReload();
  initSite();
}

// Age gate
document.addEventListener("DOMContentLoaded", () => {
  document.body.classList.add("is-loaded");
  cookieConent();
  setupAgeVerification({
    onShow: () => {
      // start light preloads if you want

      window.preloadAfterAgeGateShow?.();
      imageSequenceIconsSwap();
    },
    onAccept: () => {
      // unlock videos if needed, then boot
      bootOnce();
    },
  });

  if (document.cookie.includes("age-verification-yes=true")) {
    bootOnce();
  }

  addIdsToSections();
  openMenuSidenav();
  const isTouch = ScrollTrigger.isTouch === 1 || matchMedia("(pointer: coarse)").matches || navigator.maxTouchPoints > 0;
  if (isTouch) {
    document.body.classList.add("is-touch");
  }

  const isMobileDevice = window.matchMedia("(pointer: coarse)").matches;
  if (isMobileDevice) {
    document.body.classList.add("is-mobile");
  } else {
    document.body.classList.add("is-desktop");
  }

  function isAndroid() {
    return /Android/i.test(navigator.userAgent || navigator.vendor || window.opera);
  }

  if (isAndroid()) {
    document.body.classList.add("is-android");
  }
});

// Optional helper to ping from anywhere after DOM mutations
window.appLayoutChanged = () => window.dispatchEvent(new CustomEvent("layout:changed"));

document.addEventListener("DOMContentLoaded", () => {
  const footerLink = document.getElementById("footer-cookies-customize");
  if (footerLink) {
    footerLink.addEventListener("click", (e) => {
      e.preventDefault();
      if (typeof window.openCookieConsent === "function") {
        window.openCookieConsent(true);
      } else {
        console.warn("openCookieConsent() is not defined yet");
      }
    });
  }
});
